import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import { ExpertProfile } from '../types';
import { showToast } from '../utils/toast';

export function useExpertProfiles() {
  const [experts, setExperts] = useState<ExpertProfile[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchExpertProfiles = async () => {
      try {
        setLoading(true);
        
        const { data, error } = await supabase
          .from('expert_profiles_with_users')
          .select('*');

        if (error) throw error;

        // Format the expert profiles
        const formattedExperts: ExpertProfile[] = data.map(expert => ({
          id: expert.id,
          userId: expert.user_id,
          specialization: expert.specialization,
          credentials: expert.credentials,
          verified: expert.verified,
          followers: expert.followers_count,
          totalAnswers: expert.total_answers,
          helpfulVotes: expert.helpful_votes,
          bio: expert.bio || 'Healthcare professional dedicated to improving health outcomes.',
          experience: `${expert.experience_years} years`,
          languages: expert.languages
        }));

        setExperts(formattedExperts);
      } catch (err) {
        console.error('Error fetching expert profiles:', err);
        setError(err instanceof Error ? err : new Error('Failed to fetch expert profiles'));
        showToast.system.error('Failed to load expert profiles');
      } finally {
        setLoading(false);
      }
    };

    fetchExpertProfiles();
  }, []);

  return {
    experts,
    loading,
    error
  };
}